$(document).on('click', '.collapse__item .main-title', function () {
    const $btn = $(this);
    const expanded = $btn.attr('aria-expanded') === 'true';

    $btn.toggleClass('active').attr('aria-expanded', String(!expanded));
    $('#' + $btn.attr('aria-controls')).stop().slideToggle('fast', 'swing');
});
